import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiGiftItem, ApiUser, GiftsApi } from '@tytapp/api';
import { PageComponent } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'app-sponsorship-view',
  templateUrl: './sponsorship-view.component.html',
  styleUrls: ['./sponsorship-view.component.scss']
})
export class SponsorshipViewComponent extends PageComponent {
  private userService = inject(UserService);
  private giftsApi = inject(GiftsApi);
  private route = inject(ActivatedRoute);

  user: ApiUser;
  sponsorshipItem: ApiGiftItem;
  code: string;
  number: string;


  async init() {
    this.subscribe(this.userService.userChanged, async user => {
      this.user = user;
    });

    this.subscribe(this.route.params, async params => {
      if (params.code) {
        this.code = params.code;
        this.number = params.number;
        try {
          this.sponsorshipItem = await this.giftsApi.getGiftItem(this.code).toPromise();
        } catch(e) {
          this.router.navigate(['/account'])
        }
      } else {
        this.router.navigate(['/account']);
      }
    })
  }

  giftItemName(gift: ApiGiftItem) {
    let split = gift.product_sku.split('_');
    let duration = gift.months ? `${gift.months} MONTHS` : this.capitalizeFirstLetter(split[1]);
    return `TYT ${this.capitalizeFirstLetter(split[0])} Membership (${duration})`;
  }

  get firstRedemption() {
    let lastIndex = this.sponsorshipItem.gift_redemptions.length - 1;
    return this.sponsorshipItem.gift_redemptions[lastIndex].redeemed_at;
  }

  get mostRecentRedemption() {
    return this.sponsorshipItem.gift_redemptions[0].redeemed_at;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  

}
